module.exports = __webpack_public_path__ + "static/media/logo-branca-simbolo.4130e9bd.svg";